export default function AGBPage() {
  return (
    <div className="mx-auto max-w-4xl px-4 py-12">
      <h1 className="mb-8 text-3xl font-bold">
        Allgemeine Geschäftsbedingungen
      </h1>
      {/* Hier AGB-Inhalt einfügen */}
      <div className="prose">
        <p>Stand: 08.11.2024</p>
        <div>
          <h2>1. Geltungsbereich</h2>
          <p>
            Diese Allgemeinen Geschäftsbedingungen (AGB) regeln das
            Vertragsverhältnis zwischen der raydak GmbH, Kalifenweg 48, 70567
            Stuttgart (im Folgenden &quot;Anbieter&quot;) und den Nutzern des
            SaaS-Services &quot;AIfred&quot; (im Folgenden &quot;Nutzer&quot;).
            AIfred ist eine Softwarelösung zur Generierung von KI-basierten
            Antworten für Selbstständige und Freelancer auf Anfragen von
            Recruitern.
          </p>

          <h2>2. Vertragsgegenstand</h2>
          <p>
            Der Anbieter stellt dem Nutzer die Software &quot;AIfred&quot; zur
            Verfügung, die über das Internet genutzt werden kann. Der Nutzer
            erhält ein nicht-ausschließliches, nicht übertragbares Recht, auf
            die Software zuzugreifen und diese im Rahmen seiner beruflichen
            Tätigkeit zu verwenden.
          </p>

          <h2>3. Zustandekommen des Vertrags</h2>
          <p>
            Der Vertrag kommt zustande, wenn der Nutzer sich auf der Website{" "}
            <a href="https://aifred.raydak.de">aifred.raydak.de</a> registriert
            und die AGB durch Anklicken des entsprechenden Feldes akzeptiert.
          </p>

          <h2>4. Leistungen des Anbieters</h2>
          <p>
            Der Anbieter stellt dem Nutzer die Möglichkeit zur Verfügung, bis zu
            fünf KI-generierte Antworten pro Monat kostenlos zu erstellen
            (Free-Tier). Nach Ausschöpfung dieses Kontingents können Credits für
            weitere Generierungen erworben werden. Die Credits sind ab Kaufdatum
            für einen Zeitraum von 30 Tagen gültig. Es handelt sich hierbei um
            ein einmaliges Zahlungssystem ohne Abonnement.
          </p>

          <h2>5. Vergütung und Zahlungsbedingungen</h2>
          <p>
            Die Nutzung des Free-Tiers ist kostenlos. Für zusätzliche
            Generierungen können Credits erworben werden. Die Preise für Credits
            sind auf der Website des Anbieters einsehbar. Die Zahlung erfolgt
            unmittelbar bei Kaufabschluss über die angebotenen Zahlungsmethoden.
            Alle Preise verstehen sich zuzüglich der jeweils geltenden
            gesetzlichen Umsatzsteuer.
          </p>

          <h2>6. Pflichten des Nutzers</h2>
          <ul>
            <li>
              Der Nutzer verpflichtet sich, den Service nur im Rahmen der
              vertraglichen und gesetzlichen Bestimmungen zu nutzen.
            </li>
            <li>
              Der Nutzer darf keine Rechte Dritter verletzen oder rechtswidrige
              Inhalte in den Service einspielen.
            </li>
            <li>
              Es obliegt dem Nutzer, regelmäßig Sicherungskopien seiner Daten
              anzufertigen.
            </li>
          </ul>

          <h2>7. Verfügbarkeit und Haftung</h2>
          <p>
            Der Anbieter bemüht sich um eine Verfügbarkeit des Services von
            mindestens 99 % im Kalenderjahresmittel. Der Anbieter haftet nur für
            Schäden, die vorsätzlich oder grob fahrlässig verursacht wurden,
            sowie bei Verletzung wesentlicher Vertragspflichten
            (Kardinalpflichten). Eine weitergehende Haftung ist ausgeschlossen,
            es sei denn, der Anbieter haftet kraft Gesetzes zwingend.
          </p>

          <h2>8. Datenschutz</h2>
          <p>
            Der Anbieter verarbeitet personenbezogene Daten des Nutzers
            ausschließlich zur Erfüllung des Vertragszwecks und gemäß den
            geltenden Datenschutzbestimmungen. Weitere Informationen finden sich
            in der Datenschutzerklärung auf der Website.
          </p>

          <h2>9. Laufzeit und Kündigung</h2>
          <p>
            Der Vertrag wird auf unbestimmte Zeit geschlossen und kann vom
            Nutzer jederzeit ohne Einhaltung einer Frist gekündigt werden.
            Credits verfallen nach Ablauf ihrer Gültigkeit von 30 Tagen ab
            Kaufdatum und werden nicht erstattet.
          </p>

          <h2>10. Schlussbestimmungen</h2>
          <ul>
            <li>Änderungen dieser AGB bedürfen der Textform.</li>
            <li>
              Es gilt ausschließlich deutsches Recht unter Ausschluss des
              UN-Kaufrechts.
            </li>
            <li>
              Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder
              werden, so wird dadurch die Wirksamkeit der übrigen Bestimmungen
              nicht berührt.
            </li>
            <li>
              Ausschließlicher Gerichtsstand ist Stuttgart, sofern der Nutzer
              Kaufmann oder juristische Person des öffentlichen Rechts ist.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
